<template lang='pug'>
  .static-links
    .link
      bf-link.combo(:to='{ name: "about-us" }')
        template(v-slot:icon)
          about-icon
        template(v-slot:text) {{ $t('About BlueFaucet') }}

    .link
      bf-link.combo(:to='{ name: "pricetable" }')
        template(v-slot:icon)
          money-icon
        template(v-slot:text) {{ $t('Price Table') }}
    
    .link
      bf-link.combo(:to='{ name: "contact-us" }')
        template(v-slot:icon)
          email-icon
        template(v-slot:text) {{ $t('Contact Us') }}

    .link
      bf-link.combo(:to='{ name: "help-center" }')
        template(v-slot:icon)
          help-icon
        template(v-slot:text) {{ $t('Help Center') }}

    .link
      bf-link.combo(:to='{ name: "privacy" }')
        template(v-slot:icon)
          privacy-icon
        template(v-slot:text) {{ $t('Privacy') }}
</template>

<script>
  export default {
    name: 'static-links.component',
  }
</script>

<style scoped lang='stylus'>
  .link
    font-size 1.3em
    padding 0px 5px
    text-align left
    margin 0
    width 100%
    box-sizing border-box
    display flex
    justify-content flex-start
    &.toggle:hover
      background 0
      transform scale(1)
    &:first-child
      border-top 0
    &:last-child
      border-bottom 0
  .router-link-active
    // color white
    filter drop-shadow( 0 0 4px rgba(255 255 255 .5) )
</style>
